import React from 'react'
import { BasePopup } from './BasePopup'
import DetailItem from 'components/card/ItemDetail'
import { Person } from 'types'

export default function UserDetailsPopup({
  showDetail,
  setShowDetail,
  person,
  title,
  decription,
  children
}: {
  title: string
  decription: string
  showDetail: boolean
  setShowDetail: React.Dispatch<React.SetStateAction<boolean>>
  person: Person
  children?: React.ReactNode
}) {
  return (
    <BasePopup
      isOpen={showDetail}
      position="center"
      title={title}
      onClose={() => setShowDetail(false)}
      description={decription}
      w='700px'
    >
      <div className="space-y-4">
        {person ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <DetailItem label="Full Name" value={person.full_name} />
              <DetailItem label="ID Number" value={person.id_number} />
              <DetailItem label="Gender" value={person.gender} />
              <DetailItem label="Age" value={person.age} />
              <DetailItem label="Phone" value={person.phone} />
              <DetailItem label="Email" value={person.email} />
              <DetailItem label="Region" value={person.region} />
              <DetailItem label="Zone" value={person.zone} />
              <DetailItem label="Subcity" value={person.subcity} />
              <DetailItem label="Woreda" value={person.woreda} />
              <DetailItem label="Town" value={person.town} />
              <DetailItem label="House Number" value={person.house_number} />
              <DetailItem label="Fayda Number" value={person.fayda_number} />
            </div>
            {children}
          </>
        ) : (
          <p className="text-gray-500 text-center">
            No person details available
          </p>
        )}
      </div>
    </BasePopup>
  )
}